import React from 'react';

import IconChat from './icon--chat.svg';

import './notice.scss';

interface NoticeProps {
  prefix?: string;
  text: string;
}

const Notice: React.FC<NoticeProps> = ({ text, prefix }) => (
  <div className="notice">
    <img src={IconChat} className="icon 24_Icon_chat" alt="" />
    <div className="notice__text">
      {prefix && <b>{prefix}: </b>}
      {text}
    </div>
  </div>
);

export default Notice;
